import { saveReadingPaneOptionQuick } from '../actions/saveReadingPaneOption';
import { ChoiceGroup, IChoiceGroupOption } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { OptionQuickCustomRenderComponentProps } from 'owa-options-core';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';

export interface ReadingPaneQuickProps extends OptionQuickCustomRenderComponentProps {
    userOptions?: UserOptionsType;
}

@reactive({
    userOptions: () => getUserConfiguration().UserOptions,
})
export default class ReadingPaneQuick extends React.Component<ReadingPaneQuickProps, {}> {
    render() {
        let { userOptions } = this.props;

        let options = [
            {
                key: `${ReadingPanePosition.Right}`,
                text: strings.options_readingPane_quickSetting_right,
            },
            {
                key: `${ReadingPanePosition.Bottom}`,
                text: strings.options_readingPane_quickSetting_bottom,
            },
            {
                key: `${ReadingPanePosition.Off}`,
                text: strings.options_readingPane_quickSetting_classic,
            },
        ];

        return (
            <ChoiceGroup
                aria-labelledby={this.props.headerAriaId}
                selectedKey={`${userOptions.GlobalReadingPanePositionReact}`}
                options={options}
                onChange={this.onChange}
            />
        );
    }

    private onChange = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption
    ) => {
        let newReadingPanePosition = parseInt(option.key, 10);
        saveReadingPaneOptionQuick(newReadingPanePosition);
    };
}
